export default "__VITE_ASSET__2f376cf6__"